// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-count {
    align-items: center;
    background: #111111;
    border: 2px solid #ffffff;
    border-radius: 999px;
    color: #ffffff;
    display: inline-flex;
    font-size: 10px;
    font-weight: 700;
    height: 18px;
    justify-content: center;
    min-width: 18px;
    padding: 0 5px;
    position: absolute;
    right: -2px;
    top: -2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/CartHeader.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb","sourcesContent":[".cart-count {\n    align-items: center;\n    background: #111111;\n    border: 2px solid #ffffff;\n    border-radius: 999px;\n    color: #ffffff;\n    display: inline-flex;\n    font-size: 10px;\n    font-weight: 700;\n    height: 18px;\n    justify-content: center;\n    min-width: 18px;\n    padding: 0 5px;\n    position: absolute;\n    right: -2px;\n    top: -2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
